import { SliceZone } from '@prismicio/react';
import { Layout } from '../../components/core';
import { PageLoading } from '../../components/page';
import { SkillTransition } from '../../content/skill/components/SkillTransition';
import { components as sliceComponents } from '../../content/skill/components/slice';
import { useSkillContext } from '../../contexts';
import { usePrevious } from '../../utils/usePrevious';
import { SelfCareQuizLanding } from './SelfCareQuizLanding';

import type { SliceContext } from '../../content/skill/components/skillTypes';

export const SelfCareQuizSlides = (): JSX.Element => {
  const { skill, slideNumber } = useSkillContext();
  const previousSlideNumber = usePrevious(slideNumber) ?? 0;

  if (!skill) {
    // Don't render while the skill context is initializing.
    return <PageLoading pageName="quiz" />;
  }

  const isGoingBack = slideNumber < previousSlideNumber;

  return (
    <Layout.View position="relative" flex={1} testID="self-care-quiz-slides">
      <SkillTransition key={1} visible={slideNumber === 1} back={isGoingBack}>
        <SelfCareQuizLanding skill={skill} />
      </SkillTransition>

      {skill.data.slices.map((slice, index) => {
        // +2 offsets it to 1-index based and accounts for the landing page.
        const iterationSlideNumber = index + 2;

        const context: SliceContext = {
          moduleId: module.id,
          questions: undefined,
          skillId: skill.id,
          slideIndex: iterationSlideNumber,
        };

        const isVisible = slideNumber === iterationSlideNumber;

        return (
          <SkillTransition key={iterationSlideNumber} visible={isVisible} back={isGoingBack}>
            <SliceZone context={context} slices={[slice]} components={sliceComponents} />
          </SkillTransition>
        );
      })}
    </Layout.View>
  );
};
